export default __webpack_public_path__ + "static/media/startPoint.0e19d8cb.svg";